import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { ContextBar, ContextButton } from '@tecuity/granite-ui'
import { useHistory } from 'react-router'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import StepButton from '../StepButton'
import SelectBatches from './Steps/SelectBatches'
import EnterTotals from './Steps/EnterTotals'
import PrintReports from './Steps/PrintReports'
import {
  PostPaymentBatches,
  GetAndSetReports,
  GetAndSetPayments,
  GetReports,
} from './PostPaymentActions'
import { setErrorToast /*setSuccessToast*/ } from '../../../actions'

const PostPaymentBatch = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [step, setStep] = useState(1)
  const { payments, selectedBatches, areTotalsValid } = useSelector(
    (state) => state.postPayment,
    shallowEqual
  )

  useEffect(() => {
    dispatch(GetAndSetReports())
  }, [])

  const SetToFirstStep = (result, message) => {
    if (result) {
      setStep(2)
    } else {
      dispatch(setErrorToast(message))
    }
  }

  const SetToSecondStep = (success, message, depositNum) => {
    if (success) {
      setStep(3)
      dispatch(GetReports(depositNum))
    } else {
      dispatch(setErrorToast(message))
    }
  }

  return (
    <React.Fragment>
      <h2 className="accounting-form-header">Post Payment Batch</h2>
      <div className="reconcile-wrapper">
        <div className="steps-sidebar">
          <StepButton
            active={step === 1}
            isValid={step > 1 ? true : undefined}
            title="Select Batches"
            stepIndex={1}
            totalSteps={2}
            setStep={1}
          />
          <StepButton
            active={step === 2}
            isValid={step > 2 ? true : undefined}
            title="Enter Totals"
            stepIndex={2}
            totalSteps={3}
            setStep={2}
          />
          <StepButton
            active={step === 3}
            isValid={step > 2 ? true : undefined}
            title="Report Summary"
            stepIndex={3}
            totalSteps={3}
            setStep={3}
          />
        </div>
        <div className="form-wrapper">
          {step == 1 ? <SelectBatches /> : step == 2 ? <EnterTotals /> : <PrintReports />}
        </div>
      </div>

      <div className="context-bar-wrapper">
        <ContextBar>
          <ContextButton
            variant="secondary"
            onClick={() => (step !== 2 ? history.push('/accounting') : setStep(1))}
          >
            {step == 1 ? 'Cancel' : step == 2 ? 'Back' : 'Close'}
          </ContextButton>
          {step != 3 && (
            <ContextButton
              rightIcon={
                <div className="arrow-wrapper right">
                  <RightArrow />
                </div>
              }
              variant="primary"
              onClick={() => {
                switch (step) {
                  case 1: {
                    dispatch(GetAndSetPayments(selectedBatches, SetToFirstStep))
                    break
                  }
                  case 2: {
                    if (areTotalsValid) {
                      dispatch(
                        PostPaymentBatches(
                          { batchIDs: selectedBatches, paymentTotals: payments },
                          SetToSecondStep
                        )
                      )
                    } else {
                      dispatch(setErrorToast("'Amount On Hand' values do not match."))
                    }

                    break
                  }
                }
              }}
              disabled={step == 1 ? !selectedBatches.length > 0 : false}
            >
              Next
            </ContextButton>
          )}
        </ContextBar>
      </div>
    </React.Fragment>
  )
}

export default PostPaymentBatch
